(ns practitest.frontend.components2.dashboard.charts.readiness-gauge
  (:require [practitest.frontend.components2.dashboard.charts.protocol :as p]
            [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.components2.dashboard.svg :refer [render!]]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.components2.dashboard.charts.gauge :as gauge]))

(defmethod p/render! ::chart/readiness-gauge [chart ctx svg-el]
  (let [chart (merge gauge/config ctx chart)]
    (->> (assoc chart :label         (get-translation "readiness-gauge.label" "Readiness Score")
                      :status-icon   true
                      :value         (:rrqi chart)
                      :display-value (:rrqi chart))
         gauge/svg
         (render! svg-el))))
